exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.report-title[data-v-5e665124] {\n  background-color:#e3e3e3 !important;\n  color:brown;\n}\n.report-content[data-v-5e665124] {\n  background-color:#e3e3e3 !important;\n}\n", ""]);

// exports
